import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'gift.hero.heading',
		defaultMessage: 'Give the Gift of Calm',
		description: 'Call to action encouraging the viewer to buy the products as gifts',
	},
	description: {
		id: 'gift.hero.description2',
		defaultMessage: 'Spread the joys of better sleep, health, and happiness.',
		description: 'Call to action encouraging the viewer to buy the products this year',
	},
	body1: {
		id: 'gift.hero.body1',
		defaultMessage: 'The #1 Mental Health and Awareness app in the world for everyone on your list',
		description: 'Call to action encouraging the viewer to buy the products this year',
	},
	body2: {
		id: 'gift.hero.body3',
		defaultMessage: ', now {discountPercent}% off!',
		description: 'Call to action encouraging the viewer to buy the products this year',
	},
	cta: {
		id: 'gift.hero.ctaNew',
		defaultMessage: 'Buy a Gift Card',
		description: 'Button copy for encouraging the viewer to buy a gift card',
	},
	secondaryCta: {
		id: 'gift.hero.secondaryCta',
		defaultMessage: 'Redeem a Gift Card',
		description: 'Button copy for directing a person to redeem a gift card',
	},
});
